import React, { Component } from "react";
import ReactDOM from "react-dom";
import { IdownloadPdfPromptComponentProps } from "../types/props";
import "./downloadPdfPromptComponent.scss";
class DownloadPdfPromptComponent extends Component<IdownloadPdfPromptComponentProps> {
  render() {
    const portal = ReactDOM.createPortal(
      <div
        className="download-pdf-prompt"
        onClick={(event) => event.stopPropagation()}
      >
        <p>
          You must view or download the current file in Your PDF before starting
          a new one.
        </p>
        <div className="download-pdf-prompt--actions">
          <button onClick={this.confirm} className="btn ampri-button-primary">
            Go to your PDF
          </button>
          <button onClick={this.cancel} className="btn ampri-button-secondary">
            Cancel
          </button>
        </div>
      </div>,
      document.getElementById("pdf-download--modal")
    );
    return <>{portal}</>;
  }
  confirm = () => {
    this.props.confirm();
  };
  cancel = () => {
    this.props.cancel();
  };
}

export default DownloadPdfPromptComponent;
